import { gql } from 'graphql-request';

export default gql`
  mutation contactRemove($id: ID) {
    contactRemove(id: $id) {
      success
    }
  }
`;
